import { Paperclip } from 'lucide-react';
import { Tooltip } from '../../../../components/Tooltip';

/**
 * A filed document's name, which DOWNLOADS it — the paperclip on its left, the full name in the
 * tooltip. The two tones are Applicants' own, and they are not a choice:
 *
 * - `cell` — inside a GRID. `slate-500` at regular weight, because a table cell never takes the dark
 *   tones; a clickable entry there is told apart by hover (12 Oct 2026, root rule).
 * - `field` — the value of a field table, where "a clickable thing is black" holds.
 */
export function FileDownloadLink({
  fileName,
  onDownload,
  tone,
}: {
  fileName: string;
  onDownload: () => void;
  tone: 'cell' | 'field';
}) {
  return (
    <Tooltip label={`Download ${fileName}`} block>
      <button
        type="button"
        onClick={onDownload}
        className={[
          'inline-flex min-w-0 max-w-full items-center gap-1 text-sm hover:underline focus:outline-none focus-visible:underline',
          tone === 'cell' ? 'text-slate-500' : 'font-medium text-slate-800',
        ].join(' ')}
      >
        <Paperclip className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        <span className="min-w-0 truncate">{fileName}</span>
        <span className="sr-only">, download</span>
      </button>
    </Tooltip>
  );
}
